import {useQuery} from "@tanstack/react-query";
import {useEffect, useMemo, useState} from "react";
import {useWorkspace} from "~/contexts/workspaceContext";
import {parseProfilePictureStoredValue} from "~/utilities/profilePictureReference";
// import {getAssetById} from "~/utilities/apis/api";
// import {useHeimdallUser} from "~/contexts/HeimdallUserContext";

export function useWorkspaceProfilePictureSrc(storedReference: unknown): {
    resolvedSrc: string | undefined;
    isLoading: boolean;
    isError: boolean;
} {
    const {workspace} = useWorkspace();
    // const {accessToken} = useHeimdallUser();

    const parsed = useMemo(() => parseProfilePictureStoredValue(storedReference), [storedReference]);

    const assetId = parsed.kind === "asset" ? parsed.assetId : null;

    const {data: blob, isLoading, isError} = useQuery({
        queryKey: ["workspace-profile-picture-asset", workspace.id, assetId],
        queryFn: async () => {
            if (assetId === null) {
                throw new Error("No asset id");
            }
            // const result = await getAssetById({
            //     workspaceId: workspace.id,
            //     assetId: assetId,
            //     intellsysBaseUrl: intellsysBaseUrl,
            //     accessToken: accessToken,
            // });
            // if (result.success === false) {
            //     throw result.error;
            // }
            // return result.data;
        },
        enabled:
            assetId !== null,
            // && intellsysBaseUrl !== "" &&
            // heimdallUser.accessToken !== "",
        staleTime: 1000 * 60 * 30,
    });

    const [objectUrl, setObjectUrl] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (blob === undefined) {
            setObjectUrl(undefined);
            return;
        }
        const url = URL.createObjectURL(blob);
        setObjectUrl(url);
        return () => {
            URL.revokeObjectURL(url);
        };
    }, [blob]);

    if (parsed.kind === "legacyUrl") {
        return {resolvedSrc: parsed.url, isLoading: false, isError: false};
    }
    if (parsed.kind === "none") {
        return {resolvedSrc: undefined, isLoading: false, isError: false};
    }
    if (isError === true) {
        return {resolvedSrc: undefined, isLoading: false, isError: true};
    }
    return {
        resolvedSrc: objectUrl,
        isLoading: isLoading,
        isError: false,
    };
}
